<template>
  <div class="form-input-wrapper">
    <label class="form-label" :for="id">
      <span>{{ label }}</span
      ><span v-if="required">*</span>
    </label>
    <div class="input-quick-select-parent input-select-main-parent">
      <select
        v-if="non_int_id != ''"
        :id="id"
        :name="name"
        v-model="non_int_id"
        :required="required"
        :disabled="disabled"
        class="input-quick-select input-select-main"
      >
        <option v-for="(d, i) in dropImport" :key="i" :value="d.id">
          {{ d.naziv }}
        </option>
      </select>
      <select
        v-else
        :id="id"
        :name="name"
        v-model="ID"
        :required="required"
        :disabled="disabled"
        class="input-quick-select input-select-main"
      >
        <option v-for="(d, i) in dropImport" :key="i" :value="d.id">
          {{ d.naziv }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  props: ["base", "base_string", "dropImport", "name", "id", "required", "label", "disabled"],
  data() {
    return {
      ID: 1,
      non_int_id: '',
    };
  },
  //nekad nece postaviti sa setTimeout pa je postavljen watcher
  //čini mi se da na ovaj nacin uvijek postavi
  watch:{
    // base:function () {
    //   this.setValue();
    // },
    // base_string:function () {
    //   this.setValue();
    // }
  },
  methods: {
    // setValue() {
    //   if (this.base != undefined && !isNaN(this.base.ID)) {
    //     this.ID = parseInt(this.base.ID);
    //   }
    //   else if (this.base_string != undefined && this.base_string != "") {
    //     this.non_int_id = this.base_string;
    //   }
    // },
  },
  mounted() {
    // let vm = this;
    // this.setValue()
    // vm.$nextTick(function () {
    //   this.inputType = vm.id;
    //   setTimeout(this.setValue, 500);
    // });
  },
};
</script>
	
	
	